import React from 'react';
import PropTypes from "prop-types";
import TabPanes from './TabPanes';
import { TabContainer } from './styles';

const TabContent = ({
  item,
  tabIndex,
  tabConfig,
  containerHeight,
  activeKey,
  accountType,
  scrolled,
  dashboard,
  xscroll,
  location,
  findExpanded,
  marginRight,
  getPageTitle,
  exportDataUpdate
}) => {  
  return (
    <TabContainer className="Analytics_GrantActivity"
      height={
        item.data !== 'null' &&
        typeof item.data === 'object' &&
        item.data.hasOwnProperty('length') &&
        item.data.length > 0
          ? containerHeight
          : 'auto'
      }
      marginRight={marginRight}
      noBorder
      yscroll={true}
      yscrollC
      xscroll={xscroll}
      onScroll={dashboard ? event => scrolled(event, item.title) : null}
    >
      <TabPanes
        findExpanded={findExpanded}
        getPageTitle={getPageTitle}
        exportDataUpdate={exportDataUpdate}
        location={location}
        itemData={item.data}
        tabIndex={tabIndex}
        tabConfig={tabConfig}
        filters={item.options}
        destComponent={item.destComponent}
        mobComponent={item.mobComponent}
        columnConfig={item.columnConfig}
        expandConfig={item.expandConfig}
        text={item.text}
        accountType={accountType}
        activeKey={activeKey}
      />
    </TabContainer>
  );
};

TabContent.propTypes = {
  accountType: PropTypes.any,
  activeKey: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  containerHeight: PropTypes.any,
  dashboard: PropTypes.any,
  findExpanded: PropTypes.any,
  getPageTitle: PropTypes.any,
  item: PropTypes.shape({
    columnConfig: PropTypes.any,
    data: PropTypes.any,
    destComponent: PropTypes.any,
    expandConfig: PropTypes.any,
    mobComponent: PropTypes.any,
    options: PropTypes.any,
    text: PropTypes.any,
    title: PropTypes.any
  }),
  location: PropTypes.any,
  marginRight: PropTypes.any,
  scrolled: PropTypes.func,
  tabConfig: PropTypes.func,
  tabIndex: PropTypes.number,
  xscroll: PropTypes.any
}

export default TabContent;
